module.exports = __webpack_public_path__ + "img/Presented.4d63c93c.png";